import { Form } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SignaturePad from '../../../../../components/SignaturePad/SignaturePad';
import { updateField } from '../../../../../contextRedux/User/UserModel';
import { RootState } from '../../../../../store';
import './UserSignatureTab.css';

const UserSignatureTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const signature = useSelector((state: RootState) => state.models.user.signature);

  const handleClientSignatureChange = (signatureData: string) => {
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      signature: signatureData,
    });

    dispatch(updateField({ field: 'signature', value: signatureData ?? null }));
  };

  return (
    <Form
      form={form}
      name='userForm'
      initialValues={{
        signature,
      }}
      layout='vertical'
      className='userSignatureTab'
    >
      <div style={{ width: '30%' }}>
        <Form.Item name='signature' rules={[{ required: true, message: 'Introduceti semnatura!' }]}>
          <SignaturePad
            canUploadSignature={true}
            valueSignature={signature!}
            onSignatureDrawn={handleClientSignatureChange}
          />
        </Form.Item>
      </div>
    </Form>
  );
};

export default UserSignatureTab;
